import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import ListTopSearch from "../../Global Functions/listTopSearch";
import { GetUserAppointmentPaymentList } from "../../Redux/Actions/homeVisitActions";
import { columnsUserPaymentList } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import StatusPaymentDropdown from "./paymentDropdown";
import toast from "react-hot-toast";

const HomeVisitPaymentList = () => {
    const dispatch = useDispatch();

    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [statusType, setStatusType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { payments, loading } = useSelector(
        (state) => state.homeVisit || {}
    );
    const total = payments.total;
    const paymentList = payments?.data;

    const fetchDetails = useCallback(
        async (page, limit, showLoader = true) => {
            const payload = {
                page,
                limit,
                is_deleted: false,
                search: debouncedSearch,
                ...(dateRange.start && {
                    start_date: dateRange.start.format("YYYY-MM-DD"),
                }),
                ...(dateRange.end && {
                    end_date: dateRange.end.format("YYYY-MM-DD"),
                }),
                ...(statusType && { payment_status: statusType }),
            };

            try {
                await dispatch(GetUserAppointmentPaymentList(payload));
                if (!showLoader) toast.success("Home visit list refreshed");
            } catch {
                if (showLoader) toast.error("Failed to fetch appointment list");
            }
        },
        [dispatch, debouncedSearch, dateRange, statusType]
    );

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchQuery);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchQuery]);


    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    useEffect(() => {
        if (total !== undefined) {
            setPagination((prev) => ({ ...prev, total }));
        }
    }, [total]);

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    const handleDateRangeApply = (start, end) => {
        if (start === null && end === null) {
            setDateRange({ start: null, end: null });
        } else {
            setDateRange({ start, end });
        }
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <>
            <div className="bookings_table">
                <div className="table_component_all">
                    <div style={{ gridColumn: "span 5", height: "auto" }}>
                        <ListTopSearch
                            h3heading="Payments List"
                            setState={setSearchQuery}
                            onCalendarClick={() => setIsDatePopupVisible(true)}
                        />
                    </div>

                    <div
                        style={{
                            position: "static",
                            marginTop: "-74.5px",
                            marginLeft: "85.5%",
                            marginBottom: "24px",
                        }}
                    >
                        <StatusPaymentDropdown
                            value={statusType}
                            onChange={(e) => setStatusType(e.target.value)}
                        />
                    </div>

                    <div className="custom_table">
                        <div style={{ width: "90%", padding: "0px 60px" }}>
                            <Table
                                dataSource={Array.isArray(paymentList) ? paymentList : []}
                                columns={columnsUserPaymentList(
                                    pagination.current,
                                    pagination.pageSize
                                )}
                                pagination={pagination}
                                loading={loading}
                                onChange={handleTableChange}
                                scroll={{ x: 1700, y: 500 }}
                                rowClassName={() => "text-center"}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <DateRangePopup
                visible={isDatePopupVisible}
                initialStart={dateRange.start}
                initialEnd={dateRange.end}
                onCancel={() => setIsDatePopupVisible(false)}
                onOk={handleDateRangeApply}
            />
        </ >
    );
};

export default HomeVisitPaymentList;
